import { useEffect, useState } from "react";

import { Button } from "atoms/button/Button";
import { TextField } from "atoms/text-field/TextField";

import { QuizStepProps } from "../useQuestionnaire";

const calculateBMI = (feet: number, inches: number, weight: number): number => {
  const height = feet * 12 + inches;
  const bmi = (weight * 703) / (height * height);
  return isNaN(bmi) ? 0 : bmi;
};

export const HeightWeight = (props: QuizStepProps) => {
  const [sliderPosition, setSliderPosition] = useState(0);
  const handleChange = (key: string, value: string) => {
    props.handleStepData(key, value);
  };

  const hasError = props.errors !== null;

  const bmi = calculateBMI(
    parseInt(props.data.Height as string),
    parseInt(props.data.Inches as string),
    parseInt(props.data.Weight as string)
  );

  useEffect(() => {
    const pos = Math.min(100, Math.max(0, (bmi - 18.5) * 8.7719298245614));
    setSliderPosition(Math.min(100, Math.max(0, pos)));
  }, [bmi]);

  return (
    <div className="flex h-full flex-col gap-3">
      <p className="pb-4 font-serif text-h3">
        What is your current height and weight?
      </p>
      <div className="text-center">
        <div className="mb-2 text-muted-foreground">Your BMI</div>
        <div className="text-6xl font-bold">{bmi.toFixed(1)}</div>
      </div>

      <div className="relative h-2 rounded-full bg-gradient-to-r from-orange-400 from-10% via-green-400 via-40% to-red to-90%">
        <div
          className="absolute top-1/2 h-4 w-4 -translate-y-1/2 rounded-full border-2 border-gray-200 bg-white shadow-lg"
          style={{
            left: `${sliderPosition}%`,
            transform: `translateX(-50%) translateY(-50%)`,
          }}
        />
      </div>
      <div className="flex space-x-4">
        <TextField
          label="Feet"
          type="number"
          invalid={hasError && props.errors?.Height !== undefined}
          value={props.data.Height as string}
          onChange={(value) => handleChange("Height", value)}
        />
        <TextField
          label="Inches"
          type="number"
          invalid={hasError && props.errors?.Inches !== undefined}
          value={props.data.Inches as string}
          onChange={(value) => handleChange("Inches", value)}
        />
      </div>
      <TextField
        label="Weight (lbs)"
        type="number"
        value={props.data.Weight as string}
        invalid={hasError && props.errors?.Weight !== undefined}
        onChange={(value) => handleChange("Weight", value)}
      />
      <div className="mt-auto">
        <Button fullWidth onClick={props.next}>
          Next Question
        </Button>
      </div>
    </div>
  );
};
